export let Spec = /*#__PURE__*/function (Spec) {
  Spec["UseWarmupData"] = "specs.siteSearch.UseWarmupData";
  Spec["ChangeSelectedTabInEditorOnEdit"] = "specs.siteSearch.ChangeSelectedTabInEditorOnEdit";
  Spec["UpgradeToNewSearch"] = "specs.siteSearch.UpgradeToNewSearch";
  Spec["ReplaceSearchBoxToSearchButton"] = "specs.siteSearch.ReplaceSearchBoxToSearchButton";
  return Spec;
}({});
//# sourceMappingURL=specs.js.map